import {
    get,
    post,
    put,
    del
  } from '../configApi'

  export async function loadBannerList(params) {
    return await get(`/banner/list/admin`, params)
  }
  export async function insertBanner(body) {
    return await post(`/banner/manage/insert`, body)
  }
  export async function updateBanner(body) {
    return await put(`/banner/manage/update`, body)
  }
  export async function updateActive(body) {
    return await put(`/banner/manage/active`, body)
  }
  export async function deleteBanner(body) {
    return await del(`/banner/manage/delete`, body)
  }
  export async function getBannerListSwap() {
    return await get(`/banner/list/listswap`)
  }
  export async function reorderBanner(body) {
    return await put(`/banner/manage/setpriorty`, body)
  }
  export async function getBannerListBin(body) {
    return await get(`/banner/list/listbin`, body)
  }
  